<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
    <meta http-equiv="Pragma" content="no-cache" />
    <meta http-equiv="Expires" content="0" />
    <meta name="description" content="Luminix — Aviation Safety & Quality Management System Platform (ICAO Doc 9859, EASA, FAA, SHGM Compliant)" />
    <meta name="keywords" content="Luminix, Safety Management System, SMS, Quality Management System, QMS, ICAO 9859, Bowtie, Risk Assessment, CAPA, EASA, SHGM, Aviation Safety" />
    <meta name="author" content="Luminix" />
    <meta name="robots" content="index, follow" />
    <meta name="application-name" content="Luminix" />
    <meta name="theme-color" content="#2563eb" />

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Luminix" />
    <meta property="og:title" content="Luminix — Safety & Quality Management System" />
    <meta property="og:description" content="Enterprise Aviation Safety, Risk & Quality Management Platform." />
    <meta property="og:image" content="/logo.png" />

    <!-- Twitter -->
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content="Luminix — Safety & Quality Management System" />
    <meta name="twitter:description" content="Enterprise Aviation Safety, Risk & Quality Management Platform." />
    <meta name="twitter:image" content="/logo.png" />

    <!-- Favicon & Icons -->
    <link rel="icon" type="image/png" href="/logo.png" />
    <link rel="shortcut icon" type="image/x-icon" href="/favicon.ico" />
    <link rel="apple-touch-icon" href="/logo.png" />
    
    <!-- Modern Enterprise Typography (Plus Jakarta Sans & Inter) -->
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
    <title>Luminix — Safety & Quality Management System</title>
  </head>
  <body style="margin: 0; background-color: #f3f5f9;">
    <div id="root"></div>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
